/**
 * @ngdoc directive
 * @name databasesNoResults
 * @module flowingly.runner.setup
 * @description This component is used to display a message when there are no results
 * @usage
 * ```
     <databases-no-results></databases-no-results>
 * ``` 
 * NOTE: Minimal content for now, but this might grow
 */
(function () {
  'use strict';

  angular.module('flowingly.runner.setup').component('databasesNoResults', {
    template: `<div class="list-no-results">No results.</div>`
  });
})();
